module.exports = __webpack_public_path__ + "img/img_28@2x.8f546891.png";